import React, { Fragment } from "react";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import { TrendingUp, TrendingDown, Group } from "@material-ui/icons";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";

import PieMatchNeedsHas from "components/services/PieMatchNeedsHas";
import BarTotalHas from "components/services/BarTotalHas";
import BarTotalNeeds from "components/services/BarTotalNeeds";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

const useStyles = makeStyles(styles);

export default function MatchBusiness() {
  const classes = useStyles();

  return (
    <Fragment>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card chart>
            <CardBody>
              <h4 className={classes.cardTitleGraphs}>
                <Group className={classes.icontext} />
                Porcentaje de coincidencias para oportunidades de negocios.
              </h4>
              <PieMatchNeedsHas />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} md={6}>
          <Card chart>
            <CardBody>
              <h4 className={classes.cardTitleGraphs}>
                <TrendingUp className={classes.icontext} />
                Recursos que se OFRECE (Oferta).
              </h4>
              <BarTotalHas />
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} md={6}>
          <Card chart>
            <CardBody>
              <h4 className={classes.cardTitleGraphs}>
                {" "}
                <TrendingDown className={classes.icontext} />
                Recursos que se NECESITA (Demanda).
              </h4>
              <BarTotalNeeds />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </Fragment>
  );
}
